module.exports = __webpack_public_path__ + "img/provider-filter.ff0d018a.svg";